import type { TranslationDictionary } from '../types';

export const gu: TranslationDictionary = {
  common: {
    appName: 'ApnaBlock',
    save: 'સાચવો',
    cancel: 'રદ કરો',
    delete: 'કાઢી નાખો',
    edit: 'સંપાદિત કરો',
    create: 'બનાવો',
    back: 'પાછા જાઓ',
    search: 'શોધો...',
    filter: 'ફિલ્ટર',
    refresh: 'રિફ્રેશ કરો',
    submit: 'સબમિટ કરો',
    loading: 'લોડ થઈ રહ્યું છે...',
    close: 'બંધ કરો',
    yes: 'હા',
    no: 'ના',
    active: 'સક્રિય',
    inactive: 'નિષ્ક્રિય',
    open: 'ખુલ્લું',
    pending: 'બાકી',
    approved: 'મંજૂર',
    rejected: 'નામંજૂર',
    completed: 'પૂર્ણ',
    inProgress: 'પ્રગતિમાં છે',
    resolved: 'ઉકેલાઈ ગયું',
    viewDetails: 'વિગતો જુઓ',
    download: 'ડાઉનલોડ કરો',
    print: 'પ્રિન્ટ કરો',
    export: 'નિકાસ કરો',
    actions: 'ક્રિયાઓ',
    status: 'સ્થિતિ',
    date: 'તારીખ',
    total: 'કુલ',
    all: 'બધા',
    reset: 'રીસેટ કરો',
    more: 'વધુ',
    select: 'પસંદ કરો',
    language: 'ભાષા',
    selectLanguage: 'ભાષા પસંદ કરો',
    saveChanges: 'ફેરફારો સાચવો',
    savedSuccessfully: 'સફળતાપૂર્વક સાચવવામાં આવ્યું',
    confirm: 'ખાતરી કરો',
    home: 'હોમ',
    favorites: 'પસંદગીઓ',
    pinned: 'પિન કરેલ',
    tenant: 'સોસાયટી / સમુદાય',
    openMenu: 'મેનુ ખોલો',
    expandMenu: 'મેનુ વિસ્તૃત કરો',
    minimizeMenu: 'મેનુ સંક્ષિપ્ત કરો',
    lightMode: 'લાઇટ મોડ',
    darkMode: 'ડાર્ક મોડ',
    accountMenu: 'ખાતું મેનુ',
    commandPalette: 'કમાન્ડ પેલેટ',
    searchPages: 'પૃષ્ઠો શોધો...',
    favorite: 'પસંદગી',
    pin: 'પિન કરો',
    calendar: 'કેલેન્ડર',
    inbox: 'ઇનબૉક્સ',
    ledger: 'ખાતાવહી',
    viewAll: 'બધું જુઓ',
    platformNoSociety: 'પ્લેટફોર્મ (કોઈ સોસાયટી નથી)',
    noSociety: 'કોઈ સોસાયટી નથી',
    trial: 'ટ્રાયલ',
    expired: 'મુદત પૂરી થઈ ગઈ',
    suspended: 'સ્થગિત',
    emptyTitle: 'અહીં હજી કંઈ નથી',
    emptyDescription: 'વિગતો અને અપડેટ્સ ઉપલબ્ધ થતાં જ અહીં દેખાશે.',
    tryAgain: 'ફરી પ્રયાસ કરો',
    somethingWentWrong: 'કંઈક ખોટું થયું',
    goBack: 'પાછા જાઓ',
    goToHome: 'હોમ પર જાઓ',
    referenceId: 'સંદર્ભ આઈડી',
    or: 'અથવા',
  },
  auth: {
    login: 'સાઇન ઇન કરો',
    logout: 'લૉગ આઉટ',
    profile: 'પ્રોફાઇલ',
    email: 'ઇમેઇલ સરનામું',
    password: 'પાસવર્ડ',
    forgotPassword: 'પાસવર્ડ ભૂલી ગયા છો?',
    sendOtp: 'ઓટીપી મોકલો',
    verifyOtp: 'ઓટીપી ચકાસો',
    mobile: 'મોબાઇલ નંબર',
    rememberMe: 'મને યાદ રાખો',
    biometricLogin: 'બાયોમેટ્રિક લૉગિન',
    changePassword: 'પાસવર્ડ બદલો',
    signOut: 'સાઇન આઉટ',
    welcome: 'સ્વાગત છે',
    signIn: 'સાઇન ઇન કરો',
    signInSubtitle: 'તમારા સોસાયટી કાર્યક્ષેત્રમાં સુરક્ષિત રીતે પ્રવેશ કરો.',
    signingInTo: '{{name}} માં સાઇન ઇન કરી રહ્યા છો',
    method: 'પદ્ધતિ',
    emailTab: 'ઇમેઇલ',
    mobileTab: 'મોબાઇલ',
    otpTab: 'ઓટીપી',
    emailLabel: 'ઇમેઇલ સરનામું',
    mobileLabel: 'મોબાઇલ નંબર',
    passwordLabel: 'પાસવર્ડ',
    enableBiometricAfterLogin: 'સાઇન ઇન પછી બાયોમેટ્રિક લૉગિન સક્ષમ કરો',
    signInWithBiometrics: 'બાયોમેટ્રિક્સ દ્વારા સાઇન ઇન કરો',
    verifyAndSignIn: 'ચકાસો અને સાઇન ઇન કરો',
    changeIdentifier: 'ઓળખ બદલો',
    enterOtpSentTo: 'તમારા {{channel}} પર મોકલેલ ઓટીપી દાખલ કરો.',
    otpCodeLabel: 'ઓટીપી કોડ',
    channelLabel: 'ચેનલ',
    emailChannel: 'ઇમેઇલ',
    smsChannel: 'એસએમએસ',
    forgotPasswordTitle: 'પાસવર્ડ ભૂલી ગયા છો',
    forgotPasswordSubtitle: 'તમારો ઇમેઇલ અથવા મોબાઇલ નંબર દાખલ કરો. અમે પાસવર્ડ રીસેટ કરવા માટે ઓટીપી મોકલીશું.',
    emailOrMobile: 'ઇમેઇલ અથવા મોબાઇલ નંબર',
    backToSignIn: 'સાઇન ઇન પર પાછા જાઓ',
    resetPasswordTitle: 'પાસવર્ડ રીસેટ કરો',
    resetPasswordSubtitle: 'તમારા ઇમેઇલ અથવા મોબાઇલ પર મોકલેલ ઓટીપી દાખલ કરો, પછી નવો પાસવર્ડ પસંદ કરો.',
    newPasswordLabel: 'નવો પાસવર્ડ',
    confirmPasswordLabel: 'પાસવર્ડની પુષ્ટિ કરો',
    updatePassword: 'પાસવર્ડ અપડેટ કરો',
    changePasswordTitle: 'પાસવર્ડ બદલો',
    changePasswordSubtitle: 'તમારો એકાઉન્ટ પાસવર્ડ અપડેટ કરો. તમે સાઇન ઇન રહેશો.',
    currentPasswordLabel: 'વર્તમાન પાસવર્ડ',
    confirmNewPasswordLabel: 'નવા પાસવર્ડની પુષ્ટિ કરો',
    savePassword: 'પાસવર્ડ સાચવો',
    passwordRequirementNotice: 'ઓછામાં ઓછા ૮ અક્ષરો સાથે મોટો અક્ષર, નાનો અક્ષર, સંખ્યા અને વિશિષ્ટ અક્ષર વાપરો.',
    bannerTagline: 'એન્ટરપ્રાઇઝ સોસાયટી કામગીરી — બેંકિંગ, વસૂલાત, મીટિંગ્સ અને રહેવાસીઓ એક જ જગ્યાએ.',
    bannerSubtext: 'કોલોનીઓ અને હાઉસિંગ સોસાયટીઓ માટે સુરક્ષિત મલ્ટી-ટેનન્ટ પ્લેટફોર્મ.',
    biometricMobileOnly: 'બાયોમેટ્રિક લૉગિન ફક્ત મોબાઇલ એપ્લિકેશન પર ઉપલબ્ધ છે.',
    biometricDesktopInfo: 'બાયોમેટ્રિક લૉગિન ApnaBlock મોબાઇલ એપ્લિકેશનમાં ઉપલબ્ધ છે.',
    signedInBiometrics: 'બાયોમેટ્રિક્સ દ્વારા સફળતાપૂર્વક સાઇન ઇન થયા',
    biometricSessionExpired: 'સત્ર સમાપ્ત અથવા રદ કરવામાં આવ્યું. કૃપા કરીને તમારા પાસવર્ડ વડે સાઇન ઇન કરો.',
    biometricAuthFailed: 'બાયોમેટ્રિક પ્રમાણીકરણ નિષ્ફળ ગયું. કૃપા કરીને પાસવર્ડ વાપરો.',
    biometricEnrollSuccess: 'બાયોમેટ્રિક લૉગિન સક્ષમ કર્યું',
    biometricEnrollCancelled: 'બાયોમેટ્રિક નોંધણી રદ થઈ. સામાન્ય લૉગિન સફળ રહ્યું.',
    welcomeMarketing: 'માર્કેટિંગ પાર્ટનર પોર્ટલમાં સ્વાગત છે',
    welcomePlatform: 'પ્લેટફોર્મ વહીવટમાં સ્વાગત છે',
    welcomeBackToast: 'પુનઃ સ્વાગત છે',
    otpSentSuccess: 'ઓટીપી સફળતાપૂર્વક મોકલવામાં આવ્યો',
    otpVerifyFailed: 'ઓટીપી ચકાસણી નિષ્ફળ ગઈ',
    loginFailed: 'લૉગિન નિષ્ફળ ગયું',
    biometricAuthReason: 'ApnaBlock માં સાઇન ઇન કરવા માટે તમારી ઓળખ ચકાસો',
    biometricAvailableFor: '{{identifier}} માટે બાયોમેટ્રિક લૉગિન ઉપલબ્ધ છે',
    biometricEnrollPrompt: 'શું {{name}} માટે બાયોમેટ્રિક લૉગિન સક્ષમ કરવું છે?',
  },
  nav: {
    dashboard: 'ડેશબોર્ડ',
    society: 'સોસાયટી',
    societySettings: 'મારી સોસાયટી',
    societyBlocks: 'બ્લોક / ટાવર',
    societyHouses: 'મકાન / ફ્લેટ',
    societyResidents: 'રહીશો',
    societyStaff: 'સ્ટાફ',
    imports: 'ડેટા આયાત',
    finance: 'નાણાં અને ખાતાઓ',
    financePayments: 'મારી ચૂકવણીઓ',
    financeCollections: 'ઉઘરાણી (સંગ્રહ)',
    financeSocietyFund: 'સોસાયટી ફંડ',
    financeSpecialCollections: 'વિશેષ સંગ્રહ',
    financeCorpusFund: 'કોર્પસ ફંડ',
    financeExpenses: 'ખર્ચાઓ',
    financeExpenseGroups: 'ખર્ચ જૂથો',
    financeWaterTanker: 'પાણીનું ટેન્કર',
    financeReimbursements: 'વળતર દાવો',
    financeBanking: 'બેંક ખાતાઓ',
    financeStatements: 'સ્ટેટમેન્ટ અને રસીદો',
    financeReports: 'નાણાકીય અહેવાલો',
    financeReconciliation: 'ચૂકવણી સમાધાન',
    security: 'સુરક્ષા અને ગેટ',
    gatePasses: 'ગેટ પાસ',
    securityDashboard: 'સુરક્ષા ડેશબોર્ડ',
    securityGates: 'ગેટ સંચાલન',
    securityShifts: 'ચોકીદાર શિફ્ટ અહેવાલો',
    securityPolicies: 'સુરક્ષા નીતિઓ',
    securityDeskPortal: 'સુરક્ષા ગેટ ડેસ્ક',
    visitors: 'મુલાકાતી ડેસ્ક',
    securityCameras: 'સીસીટીવી કેમેરા',
    community: 'સમુદાય અને સંદેશાવ્યવહાર',
    notices: 'સૂચનાઓ',
    communityForum: 'સામુદાયિક મંચ',
    events: 'કાર્યક્રમો',
    eventsList: 'કાર્યક્રમો',
    eventsCalendar: 'ઇવેન્ટ કેલેન્ડર',
    invitations: 'આમંત્રણ અને પ્રતિભાવ',
    whatsapp: 'વોટ્સએપ લૉગ્સ',
    notifications: 'સૂચનાઓ',
    operations: 'કામગીરી અને સહાયતા',
    complaints: 'ફરિયાદો',
    serviceRequests: 'સેવા વિનંતીઓ',
    serviceDirectory: 'સેવા ડિરેક્ટરી',
    amenities: 'સુવિધાઓ',
    meetings: 'મીટિંગ્સ',
    documents: 'દસ્તાવેજ વૉલ્ટ',
    governance: 'શાસન અને ચૂંટણી',
    polls: 'રહીશ મતદાન',
    elections: 'ચૂંટણી',
    governancePetitions: 'અરજી દાખલ કરો',
    governanceResignation: 'રાજીનામું સબમિટ કરો',
    administration: 'વહીવટ',
    adminLicense: 'લાઇસન્સ',
    adminInvoices: 'સબ્સ્ક્રિપ્શન ઇન્વૉઇસ',
    adminRoles: 'ભૂમિકાઓ અને પરવાનગીઓ',
    adminLetterhead: 'લેટરહેડ અને બ્રાન્ડિંગ',
    adminIntegrations: 'એસએમએસ અને વોટ્સએપ',
    adminAiConfig: 'એઆઈ ગોઠવણી',
    adminNavigation: 'મેનુ કસ્ટમાઇઝેશન',
    adminAudit: 'ઓડિટ લૉગ્સ',
    documentationGroup: 'સહાય અને દસ્તાવેજીકરણ',
    societySupportDesk: 'સહાય અને સપોર્ટ',
    docsKnowledgeBase: 'જ્ઞાન કેન્દ્ર',
    docsRoleMatrix: 'ભૂમિકા અને પરવાનગી મેટ્રિક્સ',
    docsQaHub: 'ક્યુએ ટેસ્ટ હબ',
    docsTestExplorer: 'ટેસ્ટ કેસ એક્સપ્લોરર',
    licenseLocked: 'લાઇસન્સ',
    platformSocietiesGroup: 'સોસાયટીઓ અને ટેનન્ટ્સ',
    platformSocieties: 'તમામ સોસાયટીઓ',
    platformSocietiesNew: 'સોસાયટી નોંધણી કરો',
    platformSocietyTypes: 'સોસાયટી પ્રકારો અને વર્ગીકરણ',
    platformTrials: 'મફત અજમાયશ',
    platformSubscriptions: 'સબ્સ્ક્રિપ્શન્સ',
    platformLicenses: 'સોફ્ટવેર લાઇસન્સ',
    platformPlans: 'સબ્સ્ક્રિપ્શન પ્લાન',
    platformInvoices: 'બિલિંગ અને ઇન્વૉઇસ',
    platformPricingOverrides: 'કિંમત ઓવરરાઇડ્સ',
    platformCoupons: 'કૂપન્સ અને ડિસ્કાઉન્ટ',
    platformPromotionGroup: 'વૃદ્ધિ અને પ્રમોશન',
    platformPromotionDashboard: 'ગ્રોથ ડેશબોર્ડ',
    platformPromotionProspects: 'સંભવિત ગ્રાહકો',
    platformPromotionCampaigns: 'ઝુંબેશો',
    platformPromotionTemplates: 'સંદેશ નમૂનાઓ',
    platformPromotionSenderProfiles: 'પ્રેષક પ્રોફાઇલ્સ',
    platformPromotionEmail: 'ઇમેઇલ માર્કેટિંગ',
    platformPromotionWhatsapp: 'વોટ્સએપ પ્રસારણ',
    platformPromotionSms: 'એસએમએસ માર્કેટિંગ',
    platformPromotionOther: 'અન્ય ચેનલો',
    platformReferrals: 'સહયોગી અને રેફરલ્સ',
    platformMarketing: 'માર્કેટિંગ સ્ટાફ',
    platformPromotionAnalytics: 'પ્રમોશન વિશ્લેષણ',
    platformPromotionSettings: 'માર્કેટિંગ સેટિંગ્સ',
    platformManagementGroup: 'પ્લેટફોર્મ અને સપોર્ટ',
    platformWebsite: 'વેબસાઇટ સીએમએસ અને બ્રાન્ડિંગ',
    platformSupportTickets: 'સપોર્ટ ટિકિટ ડેસ્ક',
    platformFeatureRequests: 'ફીચર વિનંતીઓ',
    platformFeatures: 'ફીચર ફ્લેગ્સ',
    platformUsers: 'પ્લેટફોર્મ સંચાલકો',
    platformCoverageAudit: 'દસ્તાવેજીકરણ કવરેજ ઓડિટ',
    platformReportsGroup: 'વિશ્લેષણ અને અહેવાલો',
    platformAnalytics: 'પ્લેટફોર્મ એનાલિટિક્સ',
    platformSystemGroup: 'સિસ્ટમ અને સુરક્ષા',
    platformSystemHealth: 'સિસ્ટમ સ્વાસ્થ્ય',
    platformAuditLogs: 'ઓડિટ લૉગ્સ',
    platformNotifications: 'ચેતવણીઓ અને સૂચનાઓ',
    platformSettings: 'વૈશ્વિક સેટિંગ્સ',
    platformDataCleanup: 'ડેટા સફાઈ',
    platformGoogleCalendar: 'ગૂગલ કેલેન્ડર એકીકરણ',
    platformMaintenance: 'ડેટાબેઝ જાળવણી',
    directory: 'રહીશ ડિરેક્ટરી',
    members: 'સભ્યો',
    houses: 'એકમો અને ફ્લેટ',
    settings: 'સેટિંગ્સ',
    myUnit: 'મારું યુનિટ',
    waterTankers: 'પાણીના ટેન્કર',
    patrol: 'ગાર્ડ પેટ્રોલિંગ',
    cameras: 'લાઇવ સીસીટીવી',
    marketplace: 'માર્કેટપ્લેસ',
    profile: 'મારી પ્રોફાઇલ',
    superAdmin: 'પ્લેટફોર્મ એડમિન',
    staff: 'સોસાયટી સ્ટાફ',
    helpDesk: 'હેલ્પડેસ્ક',
    favorites: 'પસંદગીઓ',
    pinned: 'પિન કરેલ',
    navGroupHome: 'હોમ',
    navGroupSociety: 'મારી સોસાયટી',
    navGroupMoney: 'નાણાં અને બાકી',
    navGroupSecurity: 'સુરક્ષા અને ગેટ',
    navGroupCommunity: 'સમુદાય',
    navGroupManagement: 'સંચાલન',
    navGroupAdmin: 'વહીવટ',
    navGroupHelp: 'મદદ અને દસ્તાવેજો',
    securityNotificationSettings: 'સુરક્ષા નીતિઓ',
    securityCcCameras: 'સીસીટીવી કેમેરા',
  },
  mobile: {
    greetingMorning: 'સુપ્રભાત, {{name}}',
    greetingAfternoon: 'શુભ બપોર, {{name}}',
    greetingEvening: 'શુભ સંધ્યા, {{name}}',
    greetingNight: 'શુભ રાત્રિ, {{name}}',
    greetingGeneric: 'સ્વાગત છે, {{name}}',
    priorityAttention: 'ધ્યાન આપવા જેવું',
    priorityAllClear: 'તમામ બાકી રકમ ચૂકવાઈ ગઈ છે',
    priorityAllClearSub: 'કોઈ બાકી મેઇન્ટેનન્સ નથી',
    payMaintenance: 'મેઇન્ટેનન્સ ચૂકવો',
    payDues: 'હમણાં ચૂકવો',
    viewDues: 'બાકી જુઓ',
    viewReceipt: 'રસીદ જુઓ',
    dueBy: 'ચૂકવણી તારીખ {{date}}',
    quickActions: 'ઝડપી કાર્યો',
    actionPay: 'બાકી ચૂકવણી',
    actionVisitors: 'મુલાકાતીઓ',
    actionRaiseIssue: 'સમસ્યા નોંધાવો',
    actionNotices: 'નોટિસ બોર્ડ',
    actionBookFacility: 'સુવિધા બુક કરો',
    actionEmergency: 'ઇમરજન્સી SOS',
    actionDirectory: 'ડિરેક્ટરી',
    actionPolls: 'વોટિંગ અને પોલ્સ',
    actionMeetings: 'મીટિંગ્સ',
    societyUpdates: 'સોસાયટી અપડેટ્સ',
    gateAndVisitors: 'ગેટ અને મુલાકાતીઓ',
    upcomingEvents: 'આગામી કાર્યક્રમો',
    maintenanceAndReceipts: 'મેઇન્ટેનન્સ અને રસીદો',
    pendingApprovals: 'બાકી મંજૂરીઓ',
    collectionsOverview: 'ઉઘરાણી વિગત',
    pendingReview: 'સમીક્ષા બાકી',
    noPendingReviews: 'બધી સમીક્ષાઓ પૂર્ણ',
    totalCollected: 'કુલ જમા થયેલ',
    totalOutstanding: 'કુલ બાકી રકમ',
    activeGatePasses: 'સક્રિય ગેટ પાસ',
    noVisitorsToday: 'આજે કોઈ મુલાકાતી આવ્યા નથી',
    noActivePasses: 'કોઈ સક્રિય પાસ નથી',
    preApproveGuest: 'મહેમાન પૂર્વ-મંજૂરી',
    recentReceipts: 'તાજેતરની રસીદો',
    noRecentReceipts: 'કોઈ તાજેતરના વ્યવહારો નથી',
    managementDesk: 'કમિટી ડેસ્ક',
    switchRole: 'દૃશ્ય બદલો',
    residentView: 'રહેવાસી દૃશ્ય',
    committeeView: 'કમિટી દૃશ્ય',
    emergencyModalTitle: 'ઇમરજન્સી SOS ચેતવણી',
    emergencyModalSubtitle: 'સિક્યુરિટી ગાર્ડ અને સોસાયટી કમિટીને તાત્કાલિક સંકટ સંદેશ મોકલો',
    tapToCall: 'ગાર્ડને કૉલ કરો',
    tapToWhatsApp: 'ઓફિસ વ્હોટ્સએપ',
    pullToRefresh: 'રિફ્રેશ કરવા નીચે ખેંચો',
    refreshing: 'રિફ્રેશ થઈ રહ્યું છે…',
    noMeetingsScheduled: 'કોઈ મીટિંગ નિર્ધારિત નથી',
    noNoticesPublished: 'કોઈ જાહેરાત પ્રકાશિત થઈ નથી',
    noUpcomingEvents: 'કોઈ આગામી કાર્યક્રમ નથી',
    viewAllNotices: 'બધી નોટિસો જુઓ',
    viewAllEvents: 'બધા કાર્યક્રમો જુઓ',
    viewAllComplaints: 'બધી ફરિયાદો જુઓ',
    sectionDiscover: 'શોધો',
    sectionEngage: 'જોડાઓ',
    sectionPay: 'ચૂકવણી',
    cardResidents: 'રહેવાસીઓ',
    cardResidentsDesc: 'તમારી સોસાયટીના લોકોને શોધો',
    cardLocalHelp: 'સ્થાનિક મદદ',
    cardLocalHelpDesc: 'રોજિંદી ઘરગથ્થુ સહાય શોધો',
    cardEmergencyContacts: 'કટોકટી સંપર્કો',
    cardEmergencyContactsDesc: 'પોલીસ, એમ્બ્યુલન્સ અને મહત્વપૂર્ણ નંબરો',
    cardHelpDesk: 'મદદ અને ફરિયાદો',
    cardHelpDeskDesc: 'સમસ્યા નોંધાવો અથવા મદદ મેળવો',
    cardFacilities: 'સુવિધાઓ',
    cardFacilitiesDesc: 'સોસાયટીની સુવિધાઓ બુક કરો',
    cardNotices: 'સોસાયટી નોટિસ',
    cardNoticesDesc: 'સોસાયટી તરફથી મહત્વપૂર્ણ અપડેટ્સ',
    cardCommunity: 'સમુદાય',
    cardCommunityDesc: 'પોલ, મીટિંગ્સ અને કાર્યક્રમો',
    cardDocuments: 'દસ્તાવેજો',
    cardDocumentsDesc: 'સોસાયટી અને અંગત દસ્તાવેજો',
    cardPaymentsDues: 'ચૂકવણી અને બાકી રકમ',
    cardPaymentsDuesDesc: 'બાકી રકમ જુઓ અને ચૂકવો',
    cardUtilities: 'ઉપયોગિતાઓ',
    cardUtilitiesDesc: 'વીજળી, પાણી અને અન્ય સુવિધાઓ',
    actionRequired: 'ધ્યાન આપવું જરૂરી',
    pendingActionSubtitle: '{{count}} બાબતો પર સમિતિની સમીક્ષા બાકી છે',
    collectionsStatus: 'ઉઘરાણી અને બાકી રકમ',
    uncollectedSocietyDues: '{{count}} બાકી ચૂકવણીઓ',
    collectedThisMonth: 'આ મહિનાની કુલ ઉઘરાણી',
    viewLedger: 'ખાતાવહી જુઓ',
    committeeActions: 'સમિતિના કાર્યો',
    postNotice: 'નોટિસ મૂકો',
    postNoticeDesc: 'સોસાયટીને સત્તાવાર નોટિસ મોકલો',
    addExpense: 'ખર્ચ ઉમેરો',
    addExpenseDesc: 'સોસાયટીનો ખર્ચ નોંધો',
    scheduleMeeting: 'મીટિંગ નક્કી કરો',
    scheduleMeetingDesc: 'સમિતિની મીટિંગનું આયોજન કરો',
    residentDirectory: 'રહેવાસી ડિરેક્ટરી',
    residentDirectoryDesc: 'રહેવાસીઓને શોધો અને સંપર્ક કરો',
    complaintsOverview: 'ફરિયાદો અને હેલ્પડેસ્ક',
    upcomingMeetingsCount: '{{count}} આગામી મીટિંગ્સ',
    viewMeetingAgenda: 'મીટિંગની વિગતો અને એજન્ડા જુઓ',
    resignOfficeTitle: 'રાજીનામું સબમિટ કરો',
    resignOfficeNotice: 'સોસાયટીના સભ્યોને ઔપચારિક રાજીનામું સબમિટ કરો',
    activeSocietyElections: 'સક્રિય સોસાયટી ચૂંટણી',
    votingLiveStatus: 'સભ્યો માટે મતદાન ચાલુ છે',
    castYourVotePrompt: 'નામાંકિત સમિતિના ઉમેદવારો માટે તમારો મત આપો',
    recentNotices: 'તાજેતરની નોટિસ',
    myComplaints: 'મારી ફરિયાદો',
    noActiveComplaints: 'કોઈ સક્રિય ફરિયાદ અથવા ટિકિટ નથી',
  },
  profile: {
    profileTitle: 'પ્રોફાઇલ અને પસંદગીઓ',
    profileSubtitle: 'તમારી અંગત વિગતો, સુરક્ષા અને એપ્લિકેશન ભાષાનું સંચાલન કરો.',
    basicDetails: 'મૂળભૂત વિગતો',
    firstName: 'પ્રથમ નામ',
    lastName: 'અંતિમ નામ',
    email: 'ઇમેઇલ',
    mobile: 'મોબાઇલ નંબર',
    saveDetails: 'વિગતો સાચવો',
    userId: 'યુઝર આઈડી',
    roles: 'સોંપાયેલ ભૂમિકાઓ',
    tenant: 'સોસાયટી / સમુદાય',
    securityBiometrics: 'સુરક્ષા અને બાયોમેટ્રિક્સ',
    securityBiometricsDesc: 'ફિંગરપ્રિન્ટ અથવા ફેસ આઈડી દ્વારા એપને ઝડપથી અનલૉક કરો.',
    biometricLoginEnabled: 'બાયોમેટ્રિક લૉગિન સક્રિય છે',
    enableBiometricLogin: 'બાયોમેટ્રિક લૉગિન સક્ષમ કરો',
    notificationPreferences: 'સૂચના પસંદગીઓ',
    notificationPreferencesDesc: 'સોસાયટી નોટિસ અને એલર્ટ્સ કેવી રીતે પ્રાપ્ત કરવા તે નિયંત્રિત કરો.',
    languagePreferences: 'એપ્લિકેશન ભાષા',
    languagePreferencesDesc: 'તમારી મૂળભૂત ભાષા પસંદ કરો. એપ હંમેશા આ ભાષામાં ખુલશે.',
    currentLanguage: 'હાલની ભાષા',
    selectDefaultLanguage: 'મૂળભૂત ભાષા પસંદ કરો',
    defaultLanguageNotice: 'તમારી પસંદગીની ભાષા સચવાયેલી છે અને દરેક વખતે એપ ખોલતી વખતે લાગુ થશે.',
    saveLanguage: 'મૂળભૂત ભાષા તરીકે સેટ કરો',
    languageUpdated: 'ભાષા પસંદગી સફળતાપૂર્વક સાચવવામાં આવી',
  },
  dashboard: {
    welcomeBack: 'ફરી સ્વાગત છે',
    welcomeBackUser: 'ફરી સ્વાગત છે, {{name}}',
    societyWorkspace: 'તમારું સોસાયટી વર્કસ્પેસ',
    platformSubtitle: 'વ્યોરા પ્લેટફોર્મ · સોસાયટીઓ અને સોફ્ટવેર લાઇસન્સ',
    registerSociety: 'સોસાયટી નોંધણી કરો',
    registerSocietyHint: 'ટેનન્ટ અને પ્રમુખ લૉગિન બનાવો',
    allSocieties: 'તમામ સોસાયટીઓ',
    allSocietiesHint: 'યાદી અને સ્થિતિ',
    softwareLicenses: 'સોફ્ટવેર લાઇસન્સ',
    softwareLicensesHint: 'સોસાયટી પસંદ કરો, લાઇસન્સ ઇશ્યૂ અથવા સમીક્ષા કરો',
    bankBalance: 'બેંક બેલેન્સ',
    outstandingDues: 'બાકી ચૂકવણીની રકમ',
    residents: 'રહીશો',
    openRequests: 'ખુલ્લી વિનંતીઓ',
    upcomingMeetings: 'આગામી મીટિંગ્સ',
    platform: 'પ્લેટફોર્મ',
    societies: 'સોસાયટીઓ',
    licenses: 'લાઇસન્સો',
    noBankAccounts: 'હજી સુધી કોઈ બેંક ખાતું નથી',
    allDuesCleared: 'તમામ બાકી રકમ ચૂકતે થઈ ગઈ છે',
    noOpenComplaints: 'કોઈ ખુલ્લી ફરિયાદ નથી',
    noMeetingsScheduled: 'કોઈ મીટિંગ નિર્ધારિત નથી',
    overdueAndOpen: '{{overdue}} મુદત વીતી ગયેલ · {{open}} ખુલ્લા બિલ',
    openBillsCount: '{{count}} ખુલ્લા બિલ',
    openBillsCountSingle: '1 ખુલ્લું બિલ',
    accountsCountThisMonth: '{{count}} ખાતા · આ મહિને {{amount}} આવ્યા',
    accountsCountThisMonthSingle: '1 ખાતું · આ મહિને {{amount}} જમા',
    residentsAndHouses: '{{residents}} રહીશો · {{houses}} મકાનો',
    residentsOnRecord: '{{count}} રેકોર્ડ પર છે',
    housesCount: '{{count}} મકાનો',
    pendingReviewOverdue: '{{pending}} સમીક્ષા હેઠળ · {{overdue}} મુદત વીતી ગયેલ',
    pendingReview: '{{count}} સમીક્ષા હેઠળ',
    statManage: 'સંચાલન',
    statSubscription: 'સબ્સ્ક્રિપ્શન',
    collectionsCashflow: 'ઉઘરાણી અને રોકડ પ્રવાહ',
    collected: 'એકત્રિત થયેલ',
    outstanding: 'બાકી રહેલ',
    thisMonthCashflow: 'આ મહિને · આવક {{credit}} / જાવક {{debit}}',
    cashflow: 'રોકડ પ્રવાહ',
    quickActions: 'ઝડપી ક્રિયાઓ',
    scheduleMeeting: 'મીટિંગ નિર્ધારિત કરો',
    scheduleMeetingHint: 'માલિકો અને કેલેન્ડરને સૂચિત કરો',
    postNotice: 'સૂચના પોસ્ટ કરો',
    postNoticeHint: 'સોસાયટીમાં જાહેરાત કરો',
    raiseComplaint: 'ફરિયાદ નોંધાવો',
    raiseComplaintHint: 'સેવા વિનંતી લૉગ કરો',
    filePetition: 'અરજી દાખલ કરો',
    filePetitionHint: 'રાજીનામું માંગો અથવા પગલાં લો',
    viewProfile: 'પ્રોફાઇલ જુઓ',
    viewProfileHint: 'ખાતું અને પરવાનગીઓ',
    publicPetitions: 'જાહેર અરજીઓ',
    openPetitions: 'ખુલ્લી અરજીઓ · તમામ સભ્યો માટે દૃશ્યક્ષમ',
    openBoard: 'બોર્ડ ખોલો',
    noMeetingsDescription: 'આગામી સમિતિ મીટિંગ્સ અહીં દેખાશે.',
    announcements: 'જાહેરાતો',
    noAnnouncements: 'કોઈ જાહેરાત નથી',
    noAnnouncementsDesc: 'પ્રકાશિત થયેલ સૂચનાઓ અહીં દેખાશે.',
    recentActivity: 'તાજેતરની પ્રવૃત્તિ',
    noActivity: 'હજી સુધી કોઈ પ્રવૃત્તિ નથી',
    noActivityDesc: 'સૂચનાઓ અને અપડેટ્સ અહીં દેખાશે.',
    recentTransactions: 'તાજેતરના વ્યવહારો',
    visitorActivity: 'મુલાકાતી પ્રવૃત્તિ',
    visitorsComingSoon: 'મુલાકાતી મોડ્યુલ ટૂંક સમયમાં આવી રહ્યું છે',
    visitorsComingSoonDesc: 'જ્યારે વિઝિટર મોડ્યુલ સક્ષમ થશે ત્યારે ગેટ લૉગ્સ અહીં દેખાશે.',
    openVisitors: 'મુલાકાતીઓ ખોલો',
    recentNotices: 'તાજેતરની નોટિસ',
    pendingComplaints: 'બાકી ફરિયાદો',
    upcomingEvents: 'આગામી કાર્યક્રમો',
    maintenanceDue: 'મેન્ટેનન્સ બાકી રકમ',
    visitorsToday: 'આજના મુલાકાતીઓ',
    viewAll: 'બધું જુઓ',
    societyOverview: 'સોસાયટી વિહંગાવલોકન',
    activeNotices: 'સક્રિય નોટિસ',
  },
  complaints: {
    title: 'હેલ્પડેસ્ક અને ફરિયાદો',
    createComplaint: 'ફરિયાદ નોંધાવો',
    category: 'શ્રેણી',
    priority: 'પ્રાથમિકતા',
    status: 'સ્થિતિ',
    description: 'વર્ણન',
    raisedBy: 'નોંધાવનાર',
    assignedTo: 'સોંપાયેલ',
    resolve: 'ઉકેલાયેલ માર્ક કરો',
    myComplaints: 'મારી ફરિયાદો',
    allComplaints: 'સોસાયટીની તમામ ફરિયાદો',
  },
  visitors: {
    title: 'મુલાકાતી સંચાલન',
    logVisitor: 'મુલાકાતી પૂર્વ-મંજૂરી',
    visitorName: 'મુલાકાતીનું નામ',
    phone: 'ફોન નંબર',
    hostUnit: 'ફ્લેટ / યુનિટ',
    purpose: 'મુલાકાતનો હેતુ',
    vehicleNumber: 'વાહન નંબર',
    checkIn: 'ચેક-ઇન',
    checkOut: 'ચેક-આઉટ',
    expectedVisitors: 'અપેક્ષિત મહેમાનો',
    activeVisitors: 'હાલમાં અંદર છે',
  },
  finance: {
    title: 'નાણાકીય અને ચૂકવણી',
    dues: 'બાકી ચૂકવણી',
    payNow: 'હવે ચૂકવો',
    transactions: 'વ્યવહાર ઇતિહાસ',
    invoices: 'મેન્ટેનન્સ બિલ',
    receipts: 'ચૂકવણી રસીદો',
    paymentHistory: 'ચૂકવણી ઇતિહાસ',
    maintenanceFee: 'માસિક મેન્ટેનન્સ ફી',
    outstandingBalance: 'કુલ બાકી',
    paid: 'ચૂકવેલ',
    unpaid: 'અવેતન',
  },
  notices: {
    title: 'સોસાયટી નોટિસ',
    createNotice: 'નોટિસ પ્રકાશિત કરો',
    important: 'મહત્વપૂર્ણ નોટિસ',
    publishedOn: 'પ્રકાશન તારીખ',
    readMore: 'સંપૂર્ણ વાંચો',
    attachments: 'જોડાયેલ દસ્તાવેજો',
    societyAnnouncements: 'સામુદાયિક જાહેરાતો',
  },
  amenities: {
    title: 'સોસાયટી સુવિધાઓ',
    bookAmenity: 'સુવિધા બુક કરો',
    myBookings: 'મારી બુકિંગ્સ',
    availableSlots: 'ઉપલબ્ધ સ્લોટ્સ',
    rules: 'નિયમો અને માર્ગદર્શિકા',
  },
  elections: {
    title: 'ચૂંટણી અને મતદાન',
    activeElections: 'સક્રિય ચૂંટણી',
    castVote: 'મત આપો',
    candidates: 'ઉમેદવારો',
    results: 'પરિણામો',
  },
  emergency: {
    emergencyAlert: 'કટોકટી ચેતવણી (EMERGENCY)',
    triggerAlert: 'એસઓએસ ચેતવણી મોકલો',
    fire: 'આગ કટોકટી',
    medical: 'તબીબી કટોકટી',
    security: 'સુરક્ષા ખતરો',
    panic: 'પેનિક બટન',
    sos: 'એસઓએસ બ્રોડકાસ્ટ',
    activeAlert: 'કટોકટી ચેતવણી ચાલુ છે',
  },
  validation: {
    required: 'આ ફીલ્ડ ફરજિયાત છે.',
    invalidEmail: 'કૃપા કરીને માન્ય ઇમેઇલ દાખલ કરો.',
    invalidMobile: 'કૃપા કરીને માન્ય ૧૦-અંકનો મોબાઇલ નંબર દાખલ કરો.',
    passwordTooShort: 'પાસવર્ડ ઓછામાં ઓછો ૮ અક્ષરોનો હોવો જોઈએ.',
    positiveNumber: 'કૃપા કરીને હકારાત્મક મૂલ્ય દાખલ કરો.',
  },
  superAdmin: {
    title: 'પ્લેટફોર્મ વહીવટ',
    dashboard: 'ડેશબોર્ડ',
    platformOverview: 'પ્લેટફોર્મ વિહંગાવલોકન',
    platformOverviewSubtitle: 'વાસ્તવિક સમય મલ્ટિ-ટેનન્ટ સોસાયટી મેટ્રિક્સ, સબ્સ્ક્રિપ્શન સ્થિતિ અને પ્લેટફોર્મ પ્રવૃત્તિ',
    totalSocieties: 'કુલ સોસાયટીઓ',
    societiesActiveAndTrial: '{{active}} સક્રિય · {{trial}} ટ્રાયલમાં',
    monthlyRecurring: 'માસિક રિકરિંગ આવક (MRR)',
    annualRecurring: 'વાર્ષિક ARR: {{arr}}',
    activeTrials: 'સક્રિય ટ્રાયલ્સ',
    expiringInDays: '30 દિવસમાં {{count}} સમાપ્ત થઈ રહ્યા છે',
    totalPlatformUsers: 'કુલ પ્લેટફોર્મ વપરાશકર્તાઓ',
    acrossAllManagedSocieties: 'તમામ સંચાલિત સોસાયટીઓમાં',
    upcomingExpirations: 'આગામી ટ્રાયલ અને લાઇસન્સ સમાપ્તિ (આગામી 30 દિવસ)',
    upcomingExpirationsSubtitle: 'ટ્રાયલ વિસ્તરણ, નવીકરણ અથવા રૂપાંતરણની જરૂર હોય તેવી સોસાયટીઓ',
    noUpcomingExpirations: 'આગામી 30 દિવસમાં કોઈ લાઇસન્સ સમાપ્તિ નથી.',
    societyName: 'સોસાયટીનું નામ',
    plan: 'પ્લાન',
    expiresIn: 'સમાપ્તિ સમય',
    manage: 'સંચાલન',
    subscriptionTierShare: 'સબ્સ્ક્રિપ્શન પ્લાન હિસ્સો',
    subscriptionTierShareSubtitle: 'પ્લાન મુજબ સક્રિય સોસાયટી વિતરણ',
    noPlanDistribution: 'કોઈ પ્લાન વિતરણ ડેટા ઉપલબ્ધ નથી',
    daysCount: '{{count}} દિવસ',
    expiredToday: 'આજે જ સમાપ્ત થયું',
    freeTrial: 'મફત ટ્રાયલ',
    analytics: 'પ્લેટફોર્મ એનાલિટિક્સ',
    societies: 'તમામ સોસાયટીઓ',
    societyTypes: 'સોસાયટી પ્રકારો',
    trials: 'મફત અજમાયશ અને ઓનબોર્ડિંગ',
    subscriptions: 'સબ્સ્ક્રિપ્શન્સ',
    licenses: 'સોફ્ટવેર લાઇસન્સ',
    plans: 'સબ્સ્ક્રિપ્શન પ્લાન',
    invoices: 'બિલિંગ અને ઇન્વૉઇસ',
    pricingOverrides: 'કિંમત નિર્ધારણ ઓવરરાઇડ',
    coupons: 'કૂપન્સ અને ડિસ્કાઉન્ટ',
    promotion: 'વૃદ્ધિ અને પ્રમોશન',
    referrals: 'સહયોગી અને રેફરલ્સ',
    marketing: 'માર્કેટિંગ કર્મચારીઓ',
    websiteCms: 'વેબસાઇટ CMS અને બ્રાન્ડિંગ',
    features: 'ફીચર ફ્લેગ્સ',
    platformUsers: 'પ્લેટફોર્મ સંચાલકો',
    systemHealth: 'સિસ્ટમ સ્થિતિ',
    auditLogs: 'ઓડિટ લોગ',
    settings: 'વૈશ્વિક સેટિંગ્સ',
    dataCleanup: 'ડેટા સફાઈ',
    maintenance: 'ડેટાબેઝ જાળવણી',
  },
  tables: {
    noRecords: 'કોઈ રેકોર્ડ મળ્યા નથી',
    rowsPerPage: 'પૃષ્ઠ દીઠ પંક્તિઓ:',
    pageOf: 'પૃષ્ઠ {{page}} / {{totalPages}}',
    filterResults: 'પરિણામો ફિલ્ટર કરો...',
    showingResults: 'કુલ {{count}} પરિણામો દર્શાવવામાં આવી રહ્યા છે',
  },
  dialogs: {
    confirmAction: 'ક્રિયાની પુષ્ટિ કરો',
    confirmDelete: 'કાઢી નાખવાની પુષ્ટિ કરો',
    areYouSure: 'શું તમે ખરેખર આગળ વધવા માંગો છો?',
    irreversibleNotice: 'આ ક્રિયા પૂર્વવત કરી શકાતી નથી.',
    discardChanges: 'અસાચવેલા ફેરફારો કાઢી નાખો?',
  },
  feedback: {
    savedSuccess: 'વિગતો સફળતાપૂર્વક સાચવવામાં આવી',
    updateSuccess: 'સફળતાપૂર્વક અપડેટ થયું',
    errorOccurred: 'ભૂલ આવી છે. કૃપા કરીને ફરી પ્રયાસ કરો.',
    languageChanged: 'ભાષા ગુજરાતીમાં બદલાઈ ગઈ છે',
    biometricEnabledSuccess: 'બાયોમેટ્રિક સુરક્ષા સક્ષમ કરવામાં આવી',
    biometricDisabledSuccess: 'બાયોમેટ્રિક સુરક્ષા અક્ષમ કરવામાં આવી',
  },
};
